/* eslint-disable import/prefer-default-export */
import { takeLatest, put, all } from 'redux-saga/effects' // eslint-disable-line
import deleteSocioEcoActions, {
    deleteSocioEcoTypes,
} from '../../../redux/collectData/deleteSocioEco'
import getSocioEcoActions from '../../../redux/donneesSocioEconomique/getSocioEcoData'
import { Delete } from '../../../serveur/axios'

function* deleteSocioEcoSagas({ response }) {
    try {
        const responseDelete = yield Delete(`economic_data/${response.id}`)
        if (responseDelete.status === 200 || responseDelete.status === 201) {
            yield all([
                yield put(
                    deleteSocioEcoActions.deleteSocioEcoSuccess(
                        responseDelete.data
                    )
                ),
                yield put(getSocioEcoActions.getSocioEcoDataRequest()),
            ])
        } else {
            yield put(
                deleteSocioEcoActions.deleteSocioEcoFailure(responseDelete.data)
            )
        }
    } catch (error) {
        yield put(deleteSocioEcoActions.deleteSocioEcoFailure(error))
    }
}

export function* deleteSocioEcoSaga() {
    yield takeLatest(
        deleteSocioEcoTypes.DELETE_SOCIO_ECO_REQUEST,
        deleteSocioEcoSagas
    )
}
